import { render, staticRenderFns } from "./LegalAdvice.vue?vue&type=template&id=ca7753ea"
import script from "./LegalAdvice.vue?vue&type=script&lang=js"
export * from "./LegalAdvice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports